<template>
  <div class="mod-home">
    <div class="home-title">
      <div class="text-title" style="">心狗个人健康平台</div>
      <div class="text-home">
        <span class="text-home-sub1">
          心狗理念
        </span>
        <span class="text-home-sub2">
          健康中国——为百姓健康保驾护航
        </span>
      </div>

    </div>

    <div class="welcome-bar">
      <span class="welcome-greeting">您好，{{ $store.state.personal_module.username }}</span>
      <span class="welcome-lastlogin">上次登录：{{ lastlogin_process }}</span>
    </div>
    <p class="weekly-title">我的健康周报</p>
    <p class="disclaimer-text">本平台数据仅供健康参考，不构成医疗诊断建议，如有不适请及时就医。</p>
    <router-view></router-view>

  </div>
</template>

<script>
export default {
  name: 'home',
  data() {
    return {
      lastlogin_process: '',
    }
  },
  created() {

  },
  mounted() {
    this.lastLoginProcess()
  },

  methods: {
    toHealthWeekly() {
      this.$router.push({ name: 'HealthReportWeekly' })
    },
    lastLoginProcess() {
      // 修改了上次登录时间差8小时的问题
      var tempdate = new Date(this.$store.state.personal_module.last_login)
      var lastlogin = tempdate
      // lastlogin.setHours(tempdate.getHours() + 8)
      lastlogin.setHours(tempdate.getHours())
      let y = lastlogin.getFullYear();
      let MM = lastlogin.getMonth() + 1;
      MM = MM < 10 ? ('0' + MM) : MM;
      let d = lastlogin.getDate();
      d = d < 10 ? ('0' + d) : d;
      let h = lastlogin.getHours();
      h = h < 10 ? ('0' + h) : h;
      let m = lastlogin.getMinutes();
      m = m < 10 ? ('0' + m) : m;
      let s = lastlogin.getSeconds();
      s = s < 10 ? ('0' + s) : s;
      this.lastlogin_process = y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;  //显示到秒
    }
  },


}
</script>

<style lang="scss" scoped>
.mod-home {
  line-height: 1;
}

.welcome-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  background-color: #f5f7fa;
  border-radius: 4px;
  margin: 10px 0 4px;
}

.welcome-greeting {
  font-size: 18px;
  font-weight: bold;
  color: #303133;
}

.welcome-lastlogin {
  font-size: 13px;
  color: #909399;
}

.weekly-title {
  font-size: 20px;
  font-weight: bold;
  padding: 6px 0 2px;
  margin: 0;
}

.disclaimer-text {
  font-size: 12px;
  color: #909399;
  margin: 2px 0 8px;
  padding: 0;
}

.home-title {
  background-image: linear-gradient(45deg, #830707, #b30808);
  padding-top: 15px;
  padding-bottom: 15px;

  .text-title {
    font-size: 40px;
    text-align: center;
    color: #ffffff;
    padding-bottom: 20px;
    font-weight: bold;
  }

  .text-home {
    text-align: center;
    font-size: 28px;
    color: rgb(255, 255, 255);

    .text-home-sub1 {
      color: #830707;
      background-color: #ffffff;
      font-weight: bold;
      border-radius: 4px;
      padding-left: 5px;
    }

    .text-home-sub2 {
      padding-left: 15px;
    }
  }
}

</style>
